import React, { FC, lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { isPreviewMode } from '../../selectors/view-mode';

const PreviewPromptModalContent = lazy(
  () => import('./PreviewPromptModalContent'),
);

const PreviewPromptModal: FC = () => {
  const isPreview = useSelector(isPreviewMode);

  if (!isPreview) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <PreviewPromptModalContent />
    </Suspense>
  );
};

export default PreviewPromptModal;
